<template>
  <!--分类模板-->
  <div
    class="template home-border"
    @click="toggleStatus"
    :class="[templateStatus ? 'success' : '', errorStatus ? 'error' : '']"
  >
    <template v-if="templateList.length">
      <div v-for="item in templateList" :key="item.id">
        <!--标题-->
        <div class="temp-title">
          <h2>{{ item.name }}</h2>
          <a href="javascript:;">更多</a>
        </div>
        <!--模板-->
        <div class="temp-list">
          <ul>
            <template v-for="(child, index) in item.template_info">
              <li :key="child.id" v-if="index < 6">
                <div class="temp-img">
                  <img :src="child.cover_url" />
                </div>
                <p class="text-hidden">{{ child.name }}</p>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-for="item in defaultTemplateList" :key="item.id">
        <!--标题-->
        <div class="temp-title">
          <h2>{{ item.name }}</h2>
          <a>更多</a>
        </div>
        <!--模板-->
        <div class="temp-list">
          <ul>
            <template v-for="(child, index) in item.template_info">
              <li :key="child.id" v-if="index < 6">
                <div class="temp-img">
                  <div :style="child.style" style="width: 150px; height: 150px">
                    <i class="iconfont icon-weibiaoti-1-03"></i>
                  </div>
                </div>
                <p class="text-hidden">{{ child.name }}</p>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </template>

    <draw-template
      :status="templateStatus"
      :parent="templateList"
      @close="close"
      @add="addTemplate"
      @save="submit"
      @remove="removeTemplate"
      @update="updateTemplate"
      @editTemp="editTemp"
      :checkedArr="checkedArr"
      ref="drawTemp"
    />
  </div>
</template>

<script>
import drawTemplate from "./drawTemplate.vue";
import { Home, HomeSetting } from "@/config/axios/new_api";

export default {
  components: { drawTemplate },
  data() {
    return {
      maxLen: 10,
      templateStatus: false,
      templateList: [],
      defaultTemplateList: [
        {
          name: "分类",
          template_info: [
            {
              style:
                "background: linear-gradient(180deg, #FECEC2 0%, #FB9F8E 100%);",
              name: "配置文字",
            },
            {
              style:
                "background: linear-gradient(180deg, #FECEC2 0%, #FB9F8E 100%);",
              name: "配置文字",
            },
            {
              style:
                "background: linear-gradient(180deg, #FECEC2 0%, #FB9F8E 100%);",
              name: "配置文字",
            },
            {
              style:
                "background: linear-gradient(180deg, #FECEC2 0%, #FB9F8E 100%);",
              name: "配置文字",
            },
            {
              style:
                "background: linear-gradient(180deg, #FECEC2 0%, #FB9F8E 100%);",
              name: "配置文字",
            },
            {
              style:
                "background: linear-gradient(180deg, #FECEC2 0%, #FB9F8E 100%);",
              name: "配置文字",
            },
          ],
        },
        {
          name: "分类",
          template_info: [
            {
              style:
                "background: linear-gradient(180deg, #FECEC2 0%, #FB9F8E 100%);",
              name: "配置文字",
            },
            {
              style:
                "background: linear-gradient(180deg, #FECEC2 0%, #FB9F8E 100%);",
              name: "配置文字",
            },
            {
              style:
                "background: linear-gradient(180deg, #FECEC2 0%, #FB9F8E 100%);",
              name: "配置文字",
            },
            {
              style:
                "background: linear-gradient(180deg, #FECEC2 0%, #FB9F8E 100%);",
              name: "配置文字",
            },
            {
              style:
                "background: linear-gradient(180deg, #FECEC2 0%, #FB9F8E 100%);",
              name: "配置文字",
            },
            {
              style:
                "background: linear-gradient(180deg, #FECEC2 0%, #FB9F8E 100%);",
              name: "配置文字",
            },
          ],
        },
      ],
      checkedArr: [],
      errorStatus: false,
    };
  },
  created() {
    this.getData();
  },
  watch: {
    templateList: {
      handler(newVal) {
        for (let i = 0; i < newVal.length; i++) {
          newVal[i].name = newVal[i].name.replace(/\s*/g, "");
        }
        if (this.checkedArr.length) {
          for (let i = this.checkedArr.length - 1; i >= 0; i--) {
            let index = this.checkedArr[i];
            if (
              newVal[index] &&
              newVal[index].name &&
              newVal[index].template_info.length
            ) {
              this.checkedArr.splice(i, 1);
            }
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    getData() {
      Home.getData({ type: 4 }).then(async (res) => {
        if (Array.isArray(res.data) && res.data.length) {
          this.templateList = res.data.map((item) => {
            item.name_edit_status = false;
            return item;
          });
          // 考虑后续多次操作 只能在第一次操作获取数据， 避免后续编辑 重复请求接口存在 删除的也会放进数组
          for (let i = 0; i < this.templateList.length; i++) {
            await this.getCheckedTempalte(this.templateList[i]);
          }
        }
      });
    },
    async getCheckedTempalte(item) {
      let data = {
        home_template_class_id: item.id,
      };
      let res = await HomeSetting.choose(data);
      item.template_info = res.data;
    },
    toggleStatus() {
      this.templateStatus = true;
    },
    editTemp(data) {
      this.templateList = data;
    },
    close() {
      this.templateStatus = false;
      this.submit();
    },
    addTemplate() {
      if (this.templateList.length < 10) {
        this.templateList.push({
          name: `-`, // 模板分类名称
          path_type: 0,
          template_info: [],
          img_name: "",
          url: "",
          directories_id: 0,
          template_id: 0,
          name_edit_status: false,
        });
      }
    },
    updateTemplate(index, obj) {
      this.$set(this.templateList, index, obj);
    },
    removeTemplate(key) {
      this.$confirm("此操作将删除当前模板？确认是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.templateList.splice(key, 1);
        let index = this.checkedArr.indexOf(key);
        if (index !== -1) {
          this.checkedArr.splice(index, 1);
        }
      });
    },
    submit() {
      let list = this.templateList;
      let arr = [];
      if (!list.length) {
        this.errorStatus = true;
        return;
      }
      for (let i = 0; i < list.length; i++) {
        if (!list[i].template_info.length || !list[i].name) {
          arr.push(i);
        }
      }
      if (arr.length) {
        this.checkedArr = arr;
        this.errorStatus = true;
      } else {
        let saveKey = [
          "name",
          "path_type",
          "template_info",
          "img_name",
          "url",
          "directories_id",
          "template_id",
        ];
        this.errorStatus = false;
        let data = JSON.parse(JSON.stringify(this.templateList));
        for (let i = 0; i < data.length; i++) {
          for (let b in data[i]) {
            if (!saveKey.includes(b)) {
              delete data[i][b];
            }
          }
          data[i].template_info = data[i].template_info.map((item, index) => {
            return {
              template_id: item.id,
              order: index,
            };
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.template {
  margin-top: 18px;
  padding: 10px;
  cursor: pointer;
  .temp-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 30px;
    height: 40px;
    line-height: 40px;
    h2 {
      font-size: 22px;
    }
    a {
      display: block;
      width: 100px;
      height: 40px;
      background: #f3f3f3;
      border-radius: 4px;
      text-align: center;
      color: #3b3946;
    }
  }
  .temp-list {
    width: 100%;
    height: 200px;
    li {
      width: 150px;
      margin-right: 60px;
      float: left;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      .temp-img {
        width: 150px;
        height: 150px;
        // background: #3b3946;
        border-radius: 8px;
        overflow: hidden;
        text-align: center;
        &:hover {
          background: $hoverColor;
        }
        ::v-deep( .el-image) {
          width: 150px;
          height: auto;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        i {
          color: #fff;
          line-height: 150px;
          font-size: 34px;
        }
      }
      p {
        line-height: 36px;
        text-align: center;
        font-size: 14px;
        width: 100%;
        padding: 0 10px;
      }
    }
  }
}
</style>
